"use client";

import { Box, Stack, Text } from "@chakra-ui/react";
import { Card } from "@/components";
import { useThemeTokens } from "@/lib/theme/tokens";
import { dashboardStickyBelowTopBar, DASHBOARD_IN_PAGE_NAV_TOP_GAP_PX } from "@/lib/layout/dashboard-sticky-top";
import { TermsMemberMobileNavPicker } from "./TermsMemberMobileNavPicker";
import { TermsMemberNavButton } from "./TermsMemberNavButton";
import {
  scrollToTermsWaiver,
  type TermsMemberNavItem,
} from "./terms-member-nav-config";

interface TermsMemberNavProps {
  items: TermsMemberNavItem[];
  activeKey: string;
  onJumpTo: (key: string) => void;
}

export const TermsMemberNav = ({
  items,
  activeKey,
  onJumpTo,
}: TermsMemberNavProps) => {
  const theme = useThemeTokens();

  if (items.length <= 1) {
    return null;
  }

  const handleMobileSelect = (key: string) => {
    onJumpTo(key);
  };

  const handleDesktopJumpTo = (item: TermsMemberNavItem) => {
    scrollToTermsWaiver(item.anchorId);
    onJumpTo(item.key);
  };

  return (
    <>
      <TermsMemberMobileNavPicker
        items={items}
        activeKey={activeKey}
        onChange={handleMobileSelect}
      />

      <Box
        display={{ base: "none", lg: "block" }}
        w="240px"
        flexShrink={0}
        position="sticky"
        top={dashboardStickyBelowTopBar(DASHBOARD_IN_PAGE_NAV_TOP_GAP_PX)}
        zIndex={10}
        alignSelf="flex-start"
        data-testid="terms-member-nav-sidebar"
      >
        <Card p={3} borderWidth="1px" borderColor={theme.borderGlass.default}>
          <Text
            fontSize="xs"
            fontWeight="600"
            color={theme.text.tertiary}
            textTransform="uppercase"
            letterSpacing="0.05em"
            mb={2}
            px={1}
          >
            Jump to
          </Text>
          <Stack spacing={1}>
            {items.map((item) => (
              <TermsMemberNavButton
                key={item.key}
                item={item}
                isActive={activeKey === item.key}
                onClick={() => handleDesktopJumpTo(item)}
              />
            ))}
          </Stack>
        </Card>
      </Box>
    </>
  );
};
